import { type RoutePath, type RouteSegments, useSegments } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns `true` when the current route is within the modals or auth stack,
 * indicating the screen is presented as an expo-router modal.
 */
export function useIsInModalStack() {
  const segments = useSegments();
  const [firstSegment] = segments;

  return firstSegment === MODALS_SEGMENT || firstSegment === AUTH_SEGMENT;
}

// ─── Constants ────────────────────────────────────────────────────────────────

const MODALS_SEGMENT = '(modals)' as const satisfies Segments[number];
const AUTH_SEGMENT = '(auth)' as const satisfies Segments[number];

// ─── Types ───────────────────────────────────────────────────────────────────

type Segments = RouteSegments<RoutePath>;
